import { render, staticRenderFns } from "./AudienceCustomersModal.vue?vue&type=template&id=a4b34c02&scoped=true"
import script from "./AudienceCustomersModal.vue?vue&type=script&lang=js"
export * from "./AudienceCustomersModal.vue?vue&type=script&lang=js"
import style0 from "./AudienceCustomersModal.vue?vue&type=style&index=0&id=a4b34c02&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4b34c02",
  null
  
)

export default component.exports